<template>
    <v-dialog persistent v-model="shareDialog" width="660" >
        <v-card tile>
            <v-toolbar color="white">
                <v-toolbar-title class="text-primary">اشتراک گذاری تیکت</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="()=>{shares = [...sharesHistory]; shareUsers = [...shareUsersHistory]; allUsers = JSON.parse(JSON.stringify(allUsersHistory)); if(noHistory && !shares.length) getAllUsersOnly(); shareDialog = false}" icon>
                    <v-icon color="primary" size="23">close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <div class="px-3 mt-2 text-grey-darken-2 position-relative" style="min-height:300px; max-height:400px; overflow-y:auto; scrollbar-width:thin">
                <p class="px-3 mb-3 text-small">از طریق کادر زیر کاربران مورد نظر خود را انتخاب نمایید. <br>کاربران با دسترسی کامل علاوه بر مشاهده تیکت، امکان ثبت پاسخ، اضافه کردن افراد دیگر، انتقال و بستن تیکت را دارا می‌باشند.</p>
                <div class="px-3">
                    <v-autocomplete
                        :items="allUsers"
                        @update:modelValue="changeUsers"
                        item-title="name"
                        item-value="id"
                        label="* جستجوی کاربر سازمانی"
                        no-data-text="موردی پیدا نشد!"
                        multiple
                        v-model="shareUsers"
                    >
                        <template #selection="data">
                            <p class="me-1 text-small">{{3 > data.index && data.index >= 0 ? data.item.title + (shareUsers[data.index + 1] && data.index != 2 ? ', ' : '') : ''}} {{shareUsers.length > 3 && data.index === 3 ? ` و ${shareUsers.length - 3} مورد دیگر ` : ''}}</p>
                        </template>
                    </v-autocomplete>
                    <div class="d-flex align-center justify-space-between">
                        <p class="text-grey-darken-2 font-weight-bold mb-2 text-small">نام و نام خانوادگی</p>
                        <p class="text-grey-darken-2 px-1 font-weight-bold text-center mb-2 text-small">دسترسی کامل</p>
                    </div>
                    <div class="d-flex align-center justify-space-between" v-if="!shares.length">
                        <v-skeleton-loader type="list-item-avatar" width="200"></v-skeleton-loader>
                        <v-skeleton-loader type="image" height="20" class="overflow-hidden" width="20"></v-skeleton-loader>
                    </div>
                    <div class="d-flex align-center" v-for="item in shares">
                        <v-avatar v-if="item.profile_picture_name" :image="item.profile_picture_name" class="rounded helpical-shadow flex-grow-0" size="40"></v-avatar>
                        <v-avatar v-else image="@/assets/img/noUser.png" class="rounded helpical-shadow flex-grow-0" size="40"></v-avatar>
                        <p class="text-grey-darken-3 ms-2 text-meta">{{ item.name }}</p>
                        <v-spacer></v-spacer>
                        <v-checkbox
                            class="mt-0 pt-0 mx-auto d-inline-block"
                            v-model="item.editable"
                        ></v-checkbox>
                    </div>
                </div>
            </div>
            <v-card-actions class="pb-4 px-5 mt-3">
                <v-btn @click="()=>{$emit('sendTicket', {shares:[...shares]} , false); sharesHistory = [...shares]; shareUsersHistory = [...shareUsers]; allUsersHistory = JSON.parse(JSON.stringify(allUsers))}" variant="flat" color="success">ثبت اطلاعات</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="()=>{shares = [...sharesHistory]; shareUsers = [...shareUsersHistory]; allUsers = JSON.parse(JSON.stringify(allUsersHistory)); shareDialog = false}" color="error" variant="text">بستن</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            shares: [],
            shareUsers: [],
            allUsers: [],
            shareUsersHistory: [],
            sharesHistory: [],
            allUsersHistory: [],
            shareDialog: false,
        };
    },
    props: {
        noHistory: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        changeUsers(val) {
            this.allUsers.forEach((el) => {
                let result = val.includes(el.id);
                if (result) {
                    if (!el.choose) {
                        el.choose = true;
                        this.shares.push({
                            user_id: el.id,
                            name: el.name,
                            editable: false,
                            profile_picture_name: el.profile_picture_name
                        });
                    }
                } else {
                    if (el.choose) {
                        el.choose = false;
                        this.shares.splice(
                            this.shares.findIndex((x) => {
                                return x.user_id == el.id;
                            }),
                            1
                        );
                    }
                }
            });
        },
        getTicketShares(ticket) {
            this.allUsers = this.$auth.user.to_departments.filter(x => x.users).map(x => x.users).flat().filter((value, index, self) => self.findIndex(x=> x.id == value.id) >= index);
            if(this.$auth.user.full_admin)
                this.allUsers = this.allUsers.filter(x => x.branch_id == ticket.branch_id || x.branch_id == -1);
            let userTickets = [ticket.owner_id, ticket.recipient_id];
            this.allUsers = this.allUsers.filter(x => !userTickets.includes(x.id));
            if (ticket.shares.length) {
                this.shares = [...ticket.shares];
                this.shareUsers = [];
                this.shares.forEach((el) => {
                    if (this.allUsers.find((x) => x.id === el.user_id)) {
                        el.name = this.allUsers.find((x) => x.id == el.user_id).name;
                        this.allUsers.find((x) => x.id == el.user_id).choose = true;
                        el.profile_picture_name = this.allUsers.find((x) => x.id == el.user_id).profile_picture_name;
                        this.shareUsers.push(el.user_id);
                    } else
                        el.delete = true;
                });
                this.allUsers = this.allUsers.map(x => this.shareUsers.includes(x.id) ? {...x, choose: true} : {...x, choose: false});
                this.shares = this.shares.filter(x => !x.delete);
            }
            this.sharesHistory = [...this.shares];
            this.shareUsersHistory = [...this.shareUsers];
            this.allUsersHistory = JSON.parse(JSON.stringify(this.allUsers));
        },
        getAllUsersOnly(branch_id = false) {
            this.allUsers = this.$auth.user.to_departments.filter(x => x.users).map(x => x.users).flat().filter((value, index, self) => self.findIndex(x=> x.id == value.id) >= index);
            if(this.$auth.user.full_admin && branch_id)
                this.allUsers = this.allUsers.filter(x => x.branch_id == branch_id || x.branch_id == -1);
            this.allUsers = this.allUsers.map(x => {return{...x,choose:false}})
            this.allUsersHistory = JSON.parse(JSON.stringify(this.allUsers));
        },
        clearAll(){
            this.shares = [];
            this.shareUsers = [];
            this.allUsers = [];
            this.sharesHistory = [];
            this.shareUsersHistory = [];
            this.allUsersHistory = [];
        }
    },
};
</script>
